(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('DefaultMarket', DefaultMarket);

    DefaultMarket.$inject = ['$resource'];

    function DefaultMarket ($resource) {
        var resourceUrl =  'api/default-market-session-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/default-market-session-settings'
        	 },
         	
         	'marketInstruments': { method: 'GET', isArray: true,
        	    url: 'api/market-instruments'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
        	 'getInstrumentTypes': {
                 method: 'GET',
                 url: 'api/instruemnt-types',
                 isArray: true,
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/default-market-session-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/update-default-market-session-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/default-market-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'getCurrentBusinessDate': {
                  method: 'GET',  
                  url: 'api/get-current-business-date',
                  transformResponse : function(data) {
  					if (data) {
  						data = angular.fromJson(data);
  					}
  					return data;
  				}
              },
            'csInstruments': { 
                method: 'GET', 
                isArray: true,
                params: {currencyPairId:'@currencyPairId'},
        	    url: 'api/market-instruments/currencyPairId/:currencyPairId'
        	 },
              
        });
    }
})();
